import constants from "./constants"

export const isRecordId = (value) => {
    return value.length > 14
}

export const isNullOrEmpty = (value) => {
    return value === null || value === '' || value === undefined
}

export const hasAsterisk = (value) => {
    return String(value).includes('*')
}

export const formatTimer = (timer) => getTimeFromDatetime(getTimerISOFormat(timer))

const getTimerISOFormat = (timer) => new Date(timer * constants.SECONDS_IN_MILLISECONDS).toISOString()

const getTimeFromDatetime = timer => {
    const START_POSITION_FORMAT = 11
    const END_POSITION_FORMAT = 19

    return timer.slice(START_POSITION_FORMAT, END_POSITION_FORMAT)
}